if (!window.helmCollectionFiltersInitialized) {
  window.helmCollectionFiltersInitialized = true;

  document.addEventListener('click', (event) => {
    const desktopTrigger = event.target.closest(
      '[data-helm-filter-toggle]'
    );

    if (desktopTrigger) {
      const wrapper = document.querySelector('.facets-vertical');
      const label = desktopTrigger.querySelector(
        '[data-helm-filter-label]'
      );

      if (!wrapper) return;

      const isOpen = wrapper.classList.toggle(
        'helm-filters-open'
      );

      desktopTrigger.setAttribute(
        'aria-expanded',
        String(isOpen)
      );

      if (label) {
        label.textContent = isOpen
          ? 'Hide Filters'
          : 'Show Filters';
      }

      return;
    }

    const mobileTrigger = event.target.closest(
      '[data-helm-mobile-filter]'
    );

    if (!mobileTrigger) return;

    event.preventDefault();

    const originalTrigger = document.querySelector(
      '.helm-collection-default-filter-trigger'
    );

    if (!originalTrigger) return;

    originalTrigger.click();
  });
}


const scrollActiveCollectionCategory = () => {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  const container = document.querySelector(
    '.helm-collection-toolbar__categories'
  );

  const active = container?.querySelector(
    '.helm-collection-toolbar__category.is-active'
  );

  if (!container || !active) return;

  requestAnimationFrame(() => {
    const left =
      active.offsetLeft -
      (container.clientWidth - active.offsetWidth) / 2;

    container.scrollTo({
      left: Math.max(0, left),
      behavior: 'auto'
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    scrollActiveCollectionCategory
  );
} else {
  scrollActiveCollectionCategory();
}

window.addEventListener('pageshow', scrollActiveCollectionCategory);

document.addEventListener(
  'shopify:section:load',
  scrollActiveCollectionCategory
);